export default {
	methods:{
		initUnauthorizedSocketEvents()
		{

		}
	}
}
